import { formatValue } from '@keen.io/charts-utils';
export var getTooltipLabel = function (_a) {
    var scale = _a.scale, settings = _a.settings, index = _a.index;
    var label = scale.domain()[index];
    if ((settings === null || settings === void 0 ? void 0 : settings.type) === 'time' && settings.formatLabel) {
        var formatLabel = settings.formatLabel;
        return formatValue(label, formatLabel);
    }
    return label;
};
